import styled from "styled-components";

export const ResetLocalOverridingStyles = styled.div`
  p {
    text-align: unset;
  }
`;